<template>
  <div>
    <!-- 商品选择弹窗 具体参考创建代采计划页面 -->
    <el-dialog
      :visible.sync="show"
      title="商品选择"
      :close-on-click-modal="false"
      width="1200px"
    >
      <el-form inline size="small">
        <el-form-item>
          <el-select v-model="search_form.search_type">
            <el-option
              v-for="item in options.search_type"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-input v-model="search_form.search_value"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              search_form.page = 1;
              toSearch();
            "
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="rs.list"
        max-height="500px"
        row-key="goods_no"
        @selection-change="selectHandle"
      >
        <el-table-column
          type="selection"
          align="center"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          prop="goods_kh"
          label="款号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品标题"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goods_no"
          label="商品货号"
          align="center"
        ></el-table-column>
        <el-table-column prop="goods_img" label="图片" align="center">
          <template slot-scope="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                v-for="(item, key) in scope.row.middle_img"
                :key="key"
                :src="item"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="plan_price"
          label="代采价"
          align="center"
        ></el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 5px">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page.sync="search_form.page"
          :page-size="search_form.psize"
          :total="rs.total"
          @current-change="toSearch"
        >
        </el-pagination>
      </div>
      <div slot="footer" style="text-align: left">
        <el-select v-model="emit.goods_label" placeholder="请选择入仓标签">
          <el-option
            v-for="item in goods_label"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>

        <el-button type="infor" @click="cancel">取消</el-button>
        <el-button type="success" @click="submit"
          >确定 ({{ emit.goods.length }})</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    goods_label: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      show: false,
      rs: {
        list: [],
        total: 0,
      },

      loading: true,

      options: {
        search_type: [
          { label: "商品名称", value: "1" },
          { label: "商品货号", value: "2" },
          { label: "商品款号", value: "3" },
        ],

        // goods_label: [
        //     {value: '1', label: '备货'},
        //     {value: '2', label:'赠品'},
        //     {value: '3', label:'特价'},
        //     {value: '4', label:'常规'},
        //     {value: '5', label:'商家自荐'},
        // ]
      },

      search_form: {
        supply_id: "",
        search_type: "1",
        search_value: "",
        page: 1,
        psize: 20,
      },

      emit: {
        goods_label: "",
        goods: [],
      },

      selection_sku: [],
    };
  },

  methods: {
    // 外部调用
    calling(supply_id) {
      this.search_form.supply_id = supply_id;
      this.clearSearchForm();
      this.clearRs();
      this.toSearch();
      this.show = true;
    },

    toSearch() {
      this.loading = true;
      this.$http
        .post("/erp/Common/selectGoodsLib", this.search_form)
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(rs.data.msg);
          }
          this.rs = rs.data.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    clearRs() {
      this.rs.list = [];
      this.rs.total = 0;
    },

    clearSearchForm() {
      this.search_form.search_type = "1";
      this.search_form.search_value = "";
      this.search_form.page = 1;
    },

    // 清理提交数据
    clearEmit() {
      this.emit.goods_label = "";
      this.emit.goods = [];
    },

    // 取消
    cancel() {
      this.clearEmit();
      this.$refs.tableRef.clearSelection();
      this.show = false;
    },

    // 确定
    submit() {
      if (this.emit.goods.length == 0) {
        return this.$message.e("请选择商品");
      }
      if (!this.emit.goods_label) {
        return this.$message.e("请选择入仓标签");
      }
      const emit_goods = [];

      this.emit.goods.forEach((row) => {
        row.sku_data.forEach((sku) => {
          // 一套组合拳
          const item = {
            ...row,
            ...sku,
            plan_num: 1,
            goods_label: this.emit.goods_label,
          };
          emit_goods.push(item);
        });
      });
      this.$emit("submit", emit_goods);
      this.cancel();
    },

    // 处理手动勾选
    selectHandle(selection) {
      this.emit.goods = selection;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/PlanGoodsSelect.vue